import React from "react";

export interface IconProps {
  width?: number;
  height?: number;
  color?: string;
}

export default function PencilOutlineIcon(props: IconProps): JSX.Element {
  const { width, height, color } = props;
  return (
    <svg
      id="Icon_Button_-_Edit"
      data-name="Icon Button - Edit"
      xmlns="http://www.w3.org/2000/svg"
      width={width || "32"}
      height={height || "32"}
      viewBox="0 0 32 32"
    >
      <rect
        id="Rectangle_1953"
        data-name="Rectangle 1953"
        width={width || "32"}
        height={height || "32"}
        rx="5"
        fill="#fff"
      />
      <g id="Icon" transform="translate(8.989 8.626)">
        <path
          id="Path_10413"
          data-name="Path 10413"
          d="M12.83,8.1l1.058,1.07L5.568,17.537l-.958-.119-.1-.951L12.83,8.1m3.2-5.1a.89.89,0,0,0-.622.258L13.781,4.884l3.333,3.333L18.74,6.591a.885.885,0,0,0,0-1.253l-2.08-2.08A.873.873,0,0,0,16.029,3Zm-3.2,2.835L3,15.665V19H6.333l9.83-9.83L12.83,5.835Z"
          transform="translate(-3.989 -3.627)"
          fill="#979797"
        />
      </g>
    </svg>
  );
}
